import { useEffect, useMemo, useState } from 'react';
import styles from './styles.module.scss';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessage } from '@fortawesome/free-solid-svg-icons';

import { AnimatePresence, motion } from 'framer-motion';
import axios from 'axios';

import errorMsg from '../Functions/errorMsg';
import successMsg from '../Functions/successMsg';

import { PuffLoader } from 'react-spinners'

import ConversationComponent from './ConversationComponent/ConversationComponent';
import MessangerComponent from './MessangerComponent/MessangerComponent';

import { useSession } from 'next-auth/react'
import { useSocket } from '../Context/socket';
import { useRouter } from 'next/router';
 
export default function Messanger() {

    const router = useRouter();
    const { data: session, status } = useSession();
    const { socket, socketConnected } = useSocket();

    const [isVisible, setIsVisible] = useState(false);

    const [convoCategory, setConvoCategory] = useState('Empty');

    const [allConvoData, setAllConvoData] = useState(null);
    const [blockedUsers, setBlockedUsers] = useState(null);
    const [displayedConvos, setDisplayedConvos] = useState(null);

    const [viewConversation, setViewConversation] = useState(null);

    const [openMessanger, setOpenMessanger] = useState(false);

    useEffect(() => {
        if(!session) return setIsVisible(false);
        if(status === 'loading') return setIsVisible(false);
        if(status === 'authenticated') return setIsVisible(true);
    }, [session, status])

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!session) return;
        if (isVisible === false) return;
        if (loading === true) return;
        if (allConvoData !== null) return;
        if (displayedConvos !== null) return;
    
        async function getConversationData() {
            setLoading(true);
            const result = await axios.post(`${window.location.origin}/api/messaging/getUserMessages`, {
                requestingUserID: session.user.token.id,
            }).catch((error) => {
                errorMsg(error?.response?.data?.status || error.toString());
            });
    
            if (result && result.status === 200) {
                const data = result.data;
    
                const getActiveConvoData = returnActiveConvoCategory(data.userMessages);
                console.log(getActiveConvoData);
    
                setAllConvoData(data.userMessages);
                setBlockedUsers(data.blockedUsers);
    
                setDisplayedConvos(sortConvosArray(getActiveConvoData.array));
                setConvoCategory(getActiveConvoData.type);
            }
    
            setLoading(false);
        }
    
        getConversationData();
    }, [session, status, isVisible]);

    function returnActiveConvoCategory(convoData) {
        if (!convoData || typeof convoData !== 'object') {
            return { type: 'Empty', array: [] };
        }
    
        // Define the categories in the order you want to check them
        const categories = ['general', 'marketplace', 'events', 'vendors', 'jobs', 'auctions', 'raffles'];
    
        // Iterate over the categories to find the first non-empty one
        for (const category of categories) {
            if (Array.isArray(convoData[category]) && convoData[category].length > 0) {
                return { type: capitalizeFirstLetter(category), array: convoData[category] };
            }
        }
    
        return { type: 'Empty', array: [] };
    }
    

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // Open Conversation based on an ID

    useEffect(() => {
        if(!session) return;
        if(status === 'loading') return;
        if(allConvoData === null) return;
        if(displayedConvos === null) return;
        if(router === null || router === undefined) return;
        if(router.query === null || router.query === undefined) return;

        if(!router.query.openConversationID) return;

        const convoID = router.query.openConversationID;

        setOpenMessanger(true);
        setViewConversation({ convoID, requestingUserID: session.user.token.id });
    
        router.replace(
            {
                pathname: router.asPath.split('?')[0],
                query: null,
            },
            undefined,
            { shallow: true }
        );

      }, [router, session, status, allConvoData, displayedConvos])

    useEffect(() => {
        if(!socket || !socketConnected || !allConvoData || !displayedConvos) return;

        socket.on('userJoinedChat', ({roomID, username}) => {
            const convoID = roomID;
            handleConvoViewed(convoID, username);
        })

        socket.on('getNewConversation', (data) => {

            const convoType = data.type;
            var editAllConvosData = { ...allConvoData };

            if(convoType === 'General') {
                if(editAllConvosData.general.some((convo) => convo._id === data._id)) return;
                editAllConvosData.general.push(data);
            }
    
            if(convoType === 'Marketplace') {
                if(editAllConvosData.marketplace.some((convo) => convo._id === data._id)) return;
                editAllConvosData.marketplace.push(data);
            }
    
            if(convoType === 'Events') {
                if(editAllConvosData.events.some((convo) => convo._id === data._id)) return;
                editAllConvosData.events.push(data);
            }
    
            if(convoType === 'Vendors') {
                if(editAllConvosData.vendors.some((convo) => convo._id === data._id)) return;
                editAllConvosData.vendors.push(data);
            }
            
            if(convoType === 'Jobs') {
                if(editAllConvosData.jobs.some((convo) => convo._id === data._id)) return;
                editAllConvosData.jobs.push(data);
            }
            
            if(convoType === 'Auctions') {
                if(editAllConvosData.auctions.some((convo) => convo._id === data._id)) return;
                editAllConvosData.auctions.push(data);
            }
    
            if(convoType === 'Raffles') {
                if(editAllConvosData.raffles.some((convo) => convo._id === data._id)) return;
                editAllConvosData.raffles.push(data);
            }

            setAllConvoData(editAllConvosData);

            if (convoType === convoCategory) {
                const newDisplayedConvos = [...displayedConvos];
                if(newDisplayedConvos.some((convo) => convo._id === data._id)) return;
                newDisplayedConvos.push(data);
                setDisplayedConvos(sortConvosArray(newDisplayedConvos));
            }
        });

        socket.on('getMsgConvo', (data) => {
            const { convoID, sender, message, timestamp, viewed } = data;
            if(blockedUsers.includes(sender)) return;

            // Update allConvoData
            const updatedAllConvoData = { ...allConvoData };
        
            // Iterate over each category in allConvoData
            for (const category in updatedAllConvoData) {
                // Find the conversation with matching convoID and update its messages
                updatedAllConvoData[category] = updatedAllConvoData[category].map(convo => {
                    if (convo._id === convoID) {
                        convo.messages.push({
                            sender: sender,
                            message: message,
                            timestamp: timestamp,
                            viewed: viewed
                        });
                    }
                    return convo;
                });
            }
        
            // Update displayedConvos
            const updatedDisplayedConvos = displayedConvos.map(convo => {
                if (convo._id === convoID) {
                    convo.messages.push({
                        sender: sender,
                        message: message,
                        timestamp: timestamp,
                        viewed: viewed
                    });
                }
                return convo;
            });
        
            // Set the updated data
            setAllConvoData(updatedAllConvoData);
            setDisplayedConvos(sortConvosArray(updatedDisplayedConvos));
        });

        return () => {
            socket.off('getNewConversation');
            socket.off('getMsgConvo');
            socket.off('userJoinedChat');
        };
    }, [socket, socketConnected, allConvoData, displayedConvos])

    function chooseConvoCategory(type) {
        if(convoCategory === type) return;

        if(type === 'General') {
            setDisplayedConvos(sortConvosArray(allConvoData.general));
        } else if(type === 'Marketplace') {
            setDisplayedConvos(sortConvosArray(allConvoData.marketplace));
        } else if(type === 'Events') {
            setDisplayedConvos(sortConvosArray(allConvoData.events));
        } else if(type === 'Vendors') {
            setDisplayedConvos(sortConvosArray(allConvoData.vendors));
        } else if(type === 'Jobs') {
            setDisplayedConvos(sortConvosArray(allConvoData.jobs));
        } else if(type === 'Auctions') {
            setDisplayedConvos(sortConvosArray(allConvoData.auctions));
        } else if(type === 'Raffles') {
            setDisplayedConvos(sortConvosArray(allConvoData.raffles));
        } else {
            return errorMsg("There was an error, please try again later");
        }

        setConvoCategory(type);
    }

    function handleNewMessage(id, message) {
        const curConvoData = { ...allConvoData };
        const curDisplayedConvos = [ ...displayedConvos ];
    
        // Update curConvoData
        for (const key in curConvoData) {
            if (curConvoData.hasOwnProperty(key)) {
                const index = curConvoData[key].findIndex(convo => convo._id === id);
                if (index !== -1) {
                    curConvoData[key][index].messages.push(message);
                    break; // Exit loop since we found the conversation
                }
            }
        }
    
        // Update curDisplayedConvos
        const indexInDisplayedConvos = curDisplayedConvos.findIndex(convo => convo._id === id);
        if (indexInDisplayedConvos !== -1) {
            curDisplayedConvos[indexInDisplayedConvos].messages.push(message);
        }
    
        // Update state
        setAllConvoData(curConvoData);
        setDisplayedConvos(sortConvosArray(curDisplayedConvos));
    }

    function handleConvoViewed(id, username) {
        const curConvoData = {...allConvoData}
        const curDisplayedConvos = [...displayedConvos]
    
        // Update convoData
        const updatedConvoData = { ...curConvoData };
    
        for (const key in updatedConvoData) {
            if (updatedConvoData.hasOwnProperty(key)) {
                updatedConvoData[key] = updatedConvoData[key].map(convo => {
                    if (convo._id === id) { // Check if convo id matches
                        const updatedMessages = convo.messages.map(message => {
                            if (!message.viewed.includes(username)) {
                                message.viewed.push(username);
                            }
                            return message;
                        });
                        return { ...convo, messages: updatedMessages };
                    } else {
                        return convo; // Return unchanged convo if id doesn't match
                    }
                });
            }
        }
    
        // Update displayedConvos
        const updatedDisplayedConvos = curDisplayedConvos.map(convo => {
            if (convo._id === id) { // Check if convo id matches
                const updatedMessages = convo.messages.map(message => {
                    if (!message.viewed.includes(username)) {
                        message.viewed.push(username);
                    }
                    return message;
                });
                return { ...convo, messages: updatedMessages };
            } else {
                return convo; // Return unchanged convo if id doesn't match
            }
        });
        setAllConvoData(updatedConvoData);
        setDisplayedConvos(sortConvosArray(updatedDisplayedConvos));
    }    

    function loadingData() {
        if(!session) return true;
        if(status === 'loading') return true;
        if(allConvoData === null) return true;
        if(displayedConvos === null) return true;
        return false;
    }

    function handleOpenMessanger() {
        if(loading === true) return;
        if(allConvoData === null) return;
        if(displayedConvos === null) return;

        if(openMessanger) {
            setOpenMessanger(false);
        } else {
            setOpenMessanger(true);
        }
    }

    function handleConvoDeleted(convoID) {
        const updatedAllConvoData = { ...allConvoData };
        for (const key in updatedAllConvoData) {
            if (updatedAllConvoData.hasOwnProperty(key)) {
                updatedAllConvoData[key] = updatedAllConvoData[key].filter(convo => convo._id !== convoID);
            }
        }

        const updatedDisplayedConvos = displayedConvos.filter(convo => convo._id !== convoID);

        setAllConvoData(updatedAllConvoData);
        setDisplayedConvos(updatedDisplayedConvos);
    
        setViewConversation(null);
        successMsg("Conversation has been removed successfully.");
    }

    function handleUserBlockingMethod(toUserBlocked) {
        if (blockedUsers.includes(toUserBlocked)) {
            const updatedBlockedUsers = blockedUsers.filter(username => username !== toUserBlocked);
            setBlockedUsers(updatedBlockedUsers);
            successMsg("User has been unblocked.");
        } else {
            const updatedBlockedUsers = [ ...blockedUsers, toUserBlocked ];
            setBlockedUsers(updatedBlockedUsers);
            successMsg("User has been blocked.");
        }
    }

    const memoizeConversationComponent = useMemo(() => <ConversationComponent allConvoData={allConvoData} displayedConvos={displayedConvos} convoCategory={convoCategory} chooseConvoCategory={chooseConvoCategory} setOpenMessanger={setOpenMessanger} setViewConversation={setViewConversation} />, [allConvoData, displayedConvos, convoCategory])
    const memoizeMessangerComponent = useMemo(() => <MessangerComponent blockedUsers={blockedUsers} handleUserBlockingMethod={handleUserBlockingMethod} handleConvoDeleted={handleConvoDeleted} handleNewMessage={handleNewMessage} handleConvoViewed={handleConvoViewed} convoID={viewConversation?.convoID} requestingUserID={viewConversation?.requestingUserID} closeMessanger={() => setViewConversation(null)} />, [viewConversation])

  return (
    <section style={{display: isVisible === true ? 'flex' : 'none'}} id={styles.wrapper}>

        <div onClick={handleOpenMessanger} id={styles.openMessanger}>
            { loadingData() && <PuffLoader size={30} color='white' /> }
            { !loadingData() && <>
                <FontAwesomeIcon icon={faMessage} id={styles.icon} />
                <h1 style={{display: countMissedMessages(allConvoData, session.user.token.username) === 0 ? 'none' : 'flex'}}>{countMissedMessages(allConvoData, session.user.token.username)}</h1>
            </> }
        </div>

        <AnimatePresence>
            {openMessanger && (
                <motion.div id={styles.container} className={styles.container} initial={{ x: '100%' }} animate={{ x: '0%' }} exit={{ x: '100%' }} transition={{ ease: 'easeOut', duration: 0.5 }} >
                    { viewConversation === null && memoizeConversationComponent }
                    { viewConversation !== null && memoizeMessangerComponent }
                </motion.div>
            )}
        </AnimatePresence>


    </section>
  )
}

function sortConvosArray(array) {
    if(!array) [];
    return array.sort((a, b) => new Date(b.messages[b.messages.length - 1].timestamp || b.timestamp) - new Date((a.messages[a.messages.length - 1].timestamp) || a.creationDate))
}

function countMissedMessages(allConvoData, username) {
    if(allConvoData === null) return 0;
    let totalMissedMessages = 0;

    Object.keys(allConvoData).forEach(category => {
        allConvoData[category].forEach(convo => {
            convo.messages.forEach(message => {
                if (!message.viewed.includes(username)) {
                    totalMissedMessages++;
                }
            });
        });
    });

    return totalMissedMessages;
}